export const SAMPLE_EULA = `THIS EULA IS ONLY BETWEEN EATON CORPORATION (“EATON”) AND THE END USER TO WHICH THE EATON WEB APPLICATION (THE “APP”) IS PROVIDED (“YOU”). BY ACCESSING, OR USING THE APP, YOU AGREE TO BE BOUND BY THIS EULA. IF YOU DO NOT AGREE WITH THE EULA, THEN DO NOT USE THIS APP.\n\nSubject to your acceptance of this EULA, Eaton grants you, a limited, nonexclusive, nontransferable, revocable license to access and use the App via the Internet for your personal and noncommercial purposes and as permitted by the Terms of Use. Eaton is the licensor of the App. You may not modify, reverse engineer, decompile, or disassemble the App, in whole or in part, or create any derivative works from or sublicense any rights in the App, unless otherwise expressly authorized in writing by Eaton. You may not translate or otherwise attempt to create the source code from the App, or rent, lease, grant a security interest in, or otherwise transfer any rights to, copy, distribute, transmit, display, perform, reproduce, publish, license, or transfer the App, or remove or alter any trademark, logo, ©, patent or other proprietary notices in the App. The App is protected by © and other intellectual property laws and treaties. Unless expressly stated in this EULA, Eaton owns all title, © and other intellectual property and proprietary rights in and to the App, and the App is licensed and not sold. You acknowledge and agree that Eaton will have no liability to you for any intellectual property infringement or violation, or for violation of this EULA or any license, arising out of or resulting from the use of the App in combination with any other product or service not approved or supplied by Eaton, or modification of the App by you or for you. If you breach this EULA, Eaton may immediately terminate this EULA, whereupon you shall immediately cease using the App. By accepting this EULA, you will have the right pursuant to this EULA to access and use the App. By using this App you will be required to provide Eaton certain personal data in accordance with the Eaton Privacy Policy (“Privacy Policy”). This data includes, but is not limited to: (a) first and last name, (b) phone number, (c) email address, (d) shopping and/or product preferences and history, (e) purchase history, and (f) device data including, but not limited to, Internet Protocol address, location data, Operating System version, and language (“Personal Data”). If you register for the App through a social profile such as Facebook or Google+, tallyo may also process and store your social network profile, which may include, but is not limited to, additional Personal Data that you choose to make accessible to Eaton such as (x) friend or contact names, (y) date of birth, and (z) likes and dislikes. You hereby agree to allow Eaton and the App to access, store and use any information directly related to the App, including, without limitation, Personal Data. Eaton agrees to comply with all applicable privacy laws in connection with its collection, storage and use of Personal Data. The Privacy Policy is incorporated herein by reference All rights not expressly granted to you are retained by Eaton. You must comply with applicable third party terms of agreement when using the App. In the event of a breach of this EULA by Eaton, Eaton's entire liability and your exclusive remedy shall be repair or replacement of the App, except that such remedy will not be available if any problem with the App arises from your violation of this EULA, accident, abuse, misapplication, abnormal or unauthorized access or use, or introduction of a virus or malicious code by a person other than Eaton. Eaton or its suppliers are solely responsible for providing maintenance and support services with respect to the App (Support Services). Support Services are governed by the policies and programs described in the Eaton-provided materials or as required under applicable law. Any software code provided to you as part of the Support Services is part of the App and subject to this EULA. You agree that access to and use of the App will not be provided by you or any employee or agent of you to any citizen of a country to which access or use thereof is barred, or to which exports or shipments are barred, by the US government, and that you will not ship, transfer or export the App into any country or use it in any manner prohibited by the United States Export Administration Act or any other export laws, restrictions or regulations (Export Laws). You represent and warrant that you are not located in or a citizen of a country that is subject to a US government embargo, that you are not listed on any US government list of prohibited or restricted parties, and that you are not otherwise prohibited under the Export Laws from receiving access to or using the App. ACCESS TO AND USE OF THE APP IS PROVIDED “AS IS.” ALTHOUGH THE APP IS BELIEVED TO BE ACCURATE, IT IS FOR INFORMATIONAL PURPOSES ONLY. YOU ASSUME TOTAL RESPONSIBILITY AND RISK FOR USE OF THE APP. EATON DOES NOT GUARANTEE CONTINUOUS, UNINTERRUPTED OR SECURE ACCESS TO OR USE OF THE APP. NO WARRANTY OR CONDITION, EXPRESS OR IMPLIED, IS MADE WITH RESPECT TO THE APP, INCLUDING, WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE. THE PARTIES AGREE THAT EATON IS NOT PROVIDING ANY WARRANTY OR OTHER ASSURANCE THAT THE APP IS FREE OF THE RIGHTFUL CLAIM OF ANY THIRD PARTY BY WAY OF INFRINGEMENT OR OTHERWISE. EATON SHALL NOT BE LIABLE TO YOU FOR SPECIAL, INCIDENTAL, CONSEQUENTIAL, EXEMPLARY OR OTHER DAMAGES RESULTING FROM ACCESS TO OR USE OF THE APP, HOWEVER CAUSED. IN NO EVENT SHALL EATON’S TOTAL LIABILITY ARISING IN CONNECTION WITH OR UNDER THIS EULA EXCEED THE TOTAL FEES ACTUALLY PAID TO EATON BY YOU UNDER THIS EULA. This EULA will be construed in accordance with the substantive laws of the State of Ohio, without regard to its principles of conflicts of law. This EULA contains the entire understanding between you and Eaton regarding its subject matter and supersedes all prior agreements between you and Eaton (oral or written) regarding such subject matter. This EULA may be modified from time to time by Eaton. Any waiver of any provision must be in writing. If any provision of this EULA is found illegal or unenforceable, the remaining provisions will remain in full force and effect. `;

export const CommonStrings = {
    Are_You_Sure: 'Are you sure you want to',
    Discard_Changes: 'Are you sure you want to discard the changes',
    Access_Denied: 'Access Denied! You do not have permission to ',
    SessionMessage: 'Your session has expired, please try again ',
    WentWrong: 'Something went wrong, please try again',
    SessionTimeOutWarningMessage: 'Your session is about to expire due to inactivity. You will be automatically logged out in:',
};


export const ButtonNames = {
    UPDATE: 'Update',
    SAVE: 'Save',
    DELETE: 'Delete',
    CANCEL: 'Cancel',
    ADD: 'Add',
    INVITE_USER: 'Invite User',
    RESET: 'Reset',
    APPLY_FILTER: 'Apply Filter',
};

export const ESstrings = {
    DrawerTitle: 'Eaton Smart Filter',
    Eaton_Logo: 'Eaton Logo',
    Session: 'Session',
    UnAuthorizedAccess: 'Unauthorized access',

    Error: 'Error',
    CancelInviteUser: 'Cancel Invite User',
    PERMISSION: 'PERMISSION',
    Success: 'Success',
    Pending: 'PENDING',
    Failure: 'Failure',
    Logged_Out: 'LOGGED OUT',
    Done: 'Done',
    Next: 'Next',
    Yes: 'Yes',
    No: 'No',
    NotAvailable: 'Not Available',
    Cancel: 'Cancel',
    UserName: 'User Name',
    SelectUser: 'Select user(s) below',
    Unique: 'unique',

    Delete: 'Delete',

    PleaseSelect: 'Please Select',
    InviteUser: 'Invite User',
    EnterEmail: 'Enter email id',
    InvitationSent: 'Invitation sent to the user.',
    delecteAchor: 'Delete Anchor',
    barrierSetting: 'Barrier setting',
    anchorTag: 'Maximum of 8 anchor you can add',
    requestInfo: 'Request Info',
    selectRequest: 'Select Request',
    selectAll: 'Select All',
    Locations: 'Locations',
    More: 'More',
    //Screen Names
    UserSelection: 'User Selection',
    API_DATA_ERROR: 'Error while fetching data.',

    //API
    TOCKEN_TYPE: 'Bearer ',
    CONTECT_TYPE_KEY: 'Content-Type',
    CONTENT_TYPE_VALUE_JSON: 'application/json',
    CONTENT_TYPE_VALUE_TEXT: 'application/text',
    CONTENT_TYPE_VALUE_FORM_DATA: 'multipart/form-data',
    SERVICE_REQUEST_URL: 'api/servicerequest/v1',
    //ERROR CODES
    ERROR_401: '401',
    ERROR_400: '400',

    USER_PROFILE: 'UserProfile',

    //Contact card Screen
    CONTACT_DETAILS: 'Contact Details',
    EMAIL: 'Email',
    CONTACT: 'Contact',
    //
    OK: 'Ok',

    //Drawer
    VERSION: 'VERSION',
    VERSION_NUMBER: process.env.REACT_APP_VERSION || '',
    ALL_RIGHTS_RESERVED: 'All Rights Reserved',
    COPYRIGHTS: `Copyright \u00A9 Eaton`,

    DYNAMIC_QUESTIONARIES: 'Dynamic CheckList Questionnaire',
    QuestionModityConfirmation_Title: 'CANCEL UPDATING QUESTION',
    QuestionModifyConfirmation_Edit_Message: `${CommonStrings.Discard_Changes} and Edit new question?`,
    QuestionModifyConfirmation_Creat_Message: `${CommonStrings.Discard_Changes} and create new question?`,
    Answer: 'Answer',

    //Data grid components
    SitesList: 'SitesList',
    LocationsList: 'LocationsList',
    SelectRequestList: 'SelectRequestList',
    UserDetails: 'UserDetails',
    SuceessModifiedCheckList_Message: 'Compliance Check List Modified Successfully',
    Publish: 'Publish',
    FunctionalityNA: 'Functionality Not Available',

    //Validation messages for Dynamic Form
    PhoneIsRequired: 'Phone number is required',
    EnterValidPhoneNumber: 'Please enter valid phone number (eg. +11234567890)',
    enetrValidPhoneNumber: 'Please enter valid phone number',
    validNo: 'Please enter valid phone number (eg. +11234567890)',
    validNoTwo: 'Please enter valid phone number (eg. (111) 222-3333)',
    EnterMaxLength: 'Please enter max',
    EnterMinLength: 'Please enter min',
    Digits: 'digits',
    Characters: 'characters',
    WorkPermit: 'Energized Electrical Work Permit',
    FieldIsRequired: 'Field is required',
    QuestionIsRequired: 'Question is required',
    SectionIsRequired: 'Section is required',
    AddFormName: 'Add Form Name here',
    FormNameIsRequired: 'Form name is required',
    AddPageName: 'Add Page Name here',
    PageNameIsRequired: 'Page name is required',
    FormCategory: 'Form Category',
    AddFormDescription: 'Add Form Description here',
    FormDescriptionIsRequired: 'Form description is required',
    SelectYourQuestion: 'Please Select Your Question',
    SelectQuestion: 'Select Question',
    HideMobilePreview: 'Hide Mobile Preview',
    ShowMobilePreview: 'Show Mobile Preview',
    AddQuestionBtn: '+ Add question',
    AddSectionBtn: '+ Add section',
    AddPageBtn: '+ Add page',
    Question: 'Question',
    FieldType: 'Field Type',
    EnterQuestion: 'Enter your question',
    EnterSection: 'Enter your section title',
    EnterComment: 'Enter your comment',
    Section: 'Section',
    Questions: 'Questions',
    MinLength: 'Min Length',
    MaxLength: 'Max Length',
    Placeholder: 'Placeholder',
    ErrorMessage: 'Error Message',
    AnswerOptionIsRequired: 'Answer option is required',
    Min2OptionsAreRequired: 'Min 2 options are required',
    Options: 'options',
    DELETE_FORM_MSG: 'Are you sure you want to delete this form ?',
    DELETE_FORM_TITLE: 'DELETE FORM',
    WITHDRAWAL_FORM_MSG: 'Are you sure you want to withdraw this form ?',
    WITHDRAWAL_FORM_TITLE: 'WITHDRAW FORM',
    SuccessDeleteForm: 'Form Deleted Successfully',
    FailureDeleteForm: 'Something went wrong while Deleting Form',

    //NFPA_Table
    ARC_RATED_Settings: 'Arc-Rated Clothing Detail',
    PPE_Settings: 'PPE Settings',
    Color_Picker: 'Color Picker',
    Color_Code: 'Color Code',
    Actions: 'Actions',
    PPE_Level_List: 'PPE Level',
    Arc_Rated_List: 'Arc Rated List',
    ArcRatedConfig_Min_IncidentEnergy_COL: 'Incident Energy (Min.)',
    ArcRatedConfig_Max_IncidentEnergy_COL: 'Incident Energy (Max.)',
    ArcRatedConfi_ClothingList_COL: 'Arc-rated Clothing Details',
    PPE_Equipment_List: 'PPE Components',
    Error_Duplicate_Color: 'Selected color already in use!! Choose a different color.',
    SRModifyConfirmation_PPESettings_Message: `${CommonStrings.Discard_Changes} and go to PPE Level Settings?`,
    SRModifyConfirmation_PPELevel_Message: `${CommonStrings.Discard_Changes} and go to PPE Level ?`,

    ARC_RATED_CLOTHINGS: 'Arc-Rated Clothing',

    //Create Org
    OrgName: 'Organization Name*',
    LocName: 'Location Name*',
    EquiName: 'Equipment Name*',
    EquipmentAssetUId: 'Equipment Id*',
    SiteName: 'Site Name*',
    Address: 'Address*',
    EquiLoc: 'Equipment Location',
    description: 'Description',
    City: 'City*',
    State: 'State*',
    Postal_Code: 'Postal Code*',
    Country: 'Country/Territory*',
    invite: 'Invite User (Optional)',
    Email: 'Email',
    role: 'User Role',
    site_name: 'Site Name',
    location: 'Location',
    Organization: 'Organization',
    Status: 'Status',
    Add_Organization: 'Add Organization',
    Active: 'Active',
    error_msg: 'Organization name already exists, Please try with another name',
    error_api_msg: 'Something went wrong while Creating Organization',
    loc_error_api_msg: 'Something went wrong while Creating Location',
    equi_error_api_msg: 'Something went wrong while Creating Equipment',
    sites_error_api_msg: 'Something went wrong while Creating Sites',
    loc_error_msg: 'Location name already exists, Please try with another name',
    Loc_error_api_msg: 'Something went wrong while Creating Location',
    site_error_msg: 'Site name already exists, Please try with another name',
    error: 'Error',
    orgSuccess: 'Organization was created successfully !!',
    siteSuccess: 'Site was created successfully !!',
    OrgModifyConfirmation_Create_Message: `${CommonStrings.Discard_Changes} and go to organization list?`,
    OrgModityConfirmation_Title: 'CANCEL UPDATING ORGANIZATION',
    LocModifyConfirmation_Create_Message: `${CommonStrings.Discard_Changes} and go to location list?`,
    EquiModifyConfirmation_Create_Message: `${CommonStrings.Discard_Changes} and go to equipment list?`,
    SiteConfirmation_Create_Message: `${CommonStrings.Discard_Changes} and go to sites list?`,
    tableView: 'List View',
    table: 'table',
    cardView: 'Card View',
    card: 'card',
    Success_delete_user: 'User Removed Successfully',

    //validation message
    orgName: 'Please enter valid organization name',
    minChar: 'Please enter minimum 2 characters',
    orgRequired: 'Organization name required',
    validName: 'Please enter valid email',
    maxChar100: 'Please enter maximum 255 characters',
    maxChar50: 'Please enter maximun 50 characters',
    maxChar130: 'Please enter maximun 130 characters',
    maxChar30: 'Please enter maximun 30 characters',
    maxChar20: 'Please enter maximun 20 characters',
    addrRequired: 'Address required',
    validCity: 'Please enter valid city',
    validloc: 'Please enter valid location',
    validEquipmentLocation: 'Please enter valid Equipment location',
    cityRequired: 'City required',
    countryRequired: 'Country required',
    StateRequired: 'State required',
    ZipRequired: 'Zip Code required',
    roleRequired: 'Role required',
    validZip: 'Please enter valid zipCode',
    min5: 'Please enter 5 digits',
    max6: 'Please enter maximum 5 digits',
    locName: 'Please enter valid Location Name',
    equiName: 'Please enter valid Equipment Name',
    validAssetId: 'Please enter valid Equipment Id',
    siteName: 'Please enter valid Site name',
    locRequired: 'Location Name required',
    equiRequired: 'Equipment Name required',
    AssetidRequired: 'Equipment Id required',
    fnameRequired: 'First Name required',
    lnameRequired: 'Last Name required',
    empRequired: 'Employee Id required',
    firstName: 'Please enter valid first name',
    lastName: 'Please enter valid last name',
    empId: 'Please enter valid employee ID',
    email_ID: 'Please enter valid email',
    job_title: 'Please enter valid job title',
    Date_Rqr: 'Date required',
    siteRequired: 'Site name required',
    SUBMIT: 'Submit',
    Back: 'Back',

    //Arc calculations
    arcAnalysis: 'Arc Analysis',
    arcResultTab: 'IEEE 1584-2018 Arc Calculations',
    nfpaResultTab: 'NFPA70E  PPE Category',
    equipmentName: 'Equipment Name',
    equipmentLocation: 'Equipment Location',

    incidentEnergy: 'Incident Energy',
    incidentEnergyRange: 'Incident Energy Range',
    PPEcategory: 'PPE category',
    availablePPEcategory: 'Available PPE category',
    arclashboundary: 'Arc Boundary',
    PPEcategoryByLocation: 'PPE Category By Location',

    normalArcResult: 'Normal Arc Result',
    incidentEnergyNormal: 'Incident Energy',
    PPEcategoryNormal: 'PPE Category',
    arcClothing: 'Arc Clothing',
    arclashboundaryNormal: 'Arc Boundary',

    reduceArcResult: 'Reduce Arc Result',
    NFPA70E_PPE_Result: 'NFPA70E PPE Result',
    incidentEnergyReduce: 'Reduce Incident Energy',
    arclashboundaryReduce: 'Reduce Arc Boundary',
    PPEcategoryReduce: 'Reduce PPE Category',
    modified: 'Modified On',
    modifiedBy: 'Performed By',
    viewResult: 'View Result',
    ARC_API_ERROR: 'Error while fetching.',

    //Arc Analysis
    General: 'General',
    equipmentInformation: 'Equipment Information',
    arcopertiontype: 'Opertion Type',
    createdBy: 'Created By',
    jobId: 'Job Id',
    systemtype: 'System Type',
    type: 'Equipment Type',
    faultcurrent: 'Fault Current',
    faultclearingtime: 'Fault Clearing Time',
    measurementtype: 'Measurement Type',
    workingdistance: 'Working Distance',
    enclosurewidth: 'Enclosure Width',
    enclosureheight: 'Enclosure Height',
    enclosuredepth: 'Enclosure Depth',
    electrodeconfiguration: 'Electrode Configuration',
    electrodegap: 'Electrode Gap',
    arcDetails: 'Result Details',
    StartDateTime: 'Start Date Time',
    EndDateTime: 'End Date Time',
    //NFPA calculations

    Location_Submission: 'Form Submission List',
    Approvals: 'Approvals',

    APPROVAL_FORM_MSG: 'Are you sure you want to Approve this form ?',
    APPROVAL_FORM_TITLE: 'FORM APPROVAL',
    REJECT_FORM_MSG: 'Are you sure you want to Reject this form ?',
    REJECT_FORM_TITLE: 'FORM REJECT',
    FORM_TEMPLATE: 'FORM TEMPLATE',

    location_library: 'Location Library',
    global_library: 'Global Eaton Library',
    organization_library: 'Organization Library',
    draft_library: 'Draft Library',

    SELECT_DATE: 'Select Date',
    ContinueSession: 'Continue',
    LogOut: 'Log Out',
    SessionTimeout: 'Session Timeout',
};

export const SCREEN_TITLES = {
    CUSTOMERS: 'Customers',
    SETTINGS: 'Settings',
    MANAGE_USERS: 'Manage Users',
    USERS_LIST: 'Users List',
    ADD_USER: 'Add User',
    SELECT_ROLE: 'Select Role',
    USER_DETAILS: 'User Details',
    ADD_SITE: 'Add Site',
    ADD_SITES: 'Add Sites',
    EDIT_SITE: 'Edit Site',
    SITE_LIST: 'Site List',
    REPORT_LOG: 'Report',
    MY_PROFILE: 'My Profile',
    RELEASE_NOTES: 'Release Notes',
    INVITE_USERS: 'Invite Users',
    EDIT_USER: 'Edit User',
    LEGAL: 'Legal',
    HELP: 'Help',
};

export const ROLES = {
    ADMIN: 'Eaton Admin',
    MANAGER: 'Manager',
    USER: 'User',
    INVALID: 'Invalid',
    org_Admin: 'Organization Admin',
    loc_Admin: 'Site Admin',
    site_User: 'Site User',
    Eaton_Admin: 'Eaton Admin',
};
